module.exports = __webpack_public_path__ + "img/default.d3f0f359.svg";